import {
  Control,
  Controller,
  FieldValues,
  FieldError,
  ControllerRenderProps,
  FieldPath,
} from "react-hook-form";
import { Input } from "keep-react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export interface FormFieldProps<TFieldValues extends FieldValues> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  label: React.ReactNode;
  placeholder: string;
  type?: string;
  disabled?: boolean;
  renderInput?: (
    field: ControllerRenderProps<TFieldValues, FieldPath<TFieldValues>>,
    error: FieldError | undefined
  ) => React.ReactNode;
  showPassword?: boolean;
  togglePassword?: () => void;
}

export function FormField<TFieldValues extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  type = "text",
  disabled = false,
  renderInput,
  showPassword = false,
  togglePassword,
}: FormFieldProps<TFieldValues>) {
  return (
    <div className="col-span-1">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error, isTouched } }) => (
          <>
            <div className="mb-1">
              <label className="text-sm font-medium text-gray-700">
                {label}
              </label>
            </div>
            {renderInput ? (
              renderInput(field, error)
            ) : (
              <div className="relative">
                <Input
                  type={
                    type === "password"
                      ? showPassword
                        ? "text"
                        : "password"
                      : type
                  }
                  placeholder={placeholder}
                  disabled={disabled}
                  className={error ? "border-red-500 focus:border-red-500" : ""}
                  {...field}
                  value={
                    field.value === null || field.value === undefined
                      ? ""
                      : String(field.value)
                  }
                  onChange={(e) => {
                    field.onChange(e);

                    if (isTouched) {
                      setTimeout(() => field.onBlur(), 100);
                    }
                  }}
                />
                {type === "password" && togglePassword && (
                  <div
                    className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                    onClick={togglePassword}
                  >
                    {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                  </div>
                )}
              </div>
            )}
            {error && (
              <p className="text-red-500 text-xs mt-1">{error.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
}